import i18n from "../i18n";

/**
 * MCC 2 "operation request status updated" notifications (sent to the referring doctor when the
 * Medical Coordination Center changes the status of an operation referral).
 *
 * Live socket events carry `notification_type: OPERATION_REQUEST_STATUS_UPDATED`; persisted bell
 * rows store the channel ("realtime") as their type, so both are recognised by the payload too.
 */
export const OPERATION_REQUEST_NOTIFICATION_TYPE = "OPERATION_REQUEST_STATUS_UPDATED";

const payloadOf = (notification) =>
  notification?.data || notification?.metadata || {};

export const isOperationRequestNotification = (notification) => {
  const type = String(
    notification?.notification_type || notification?.notificationType || "",
  ).toUpperCase();
  return (
    type === OPERATION_REQUEST_NOTIFICATION_TYPE ||
    Boolean(payloadOf(notification).operation_referral_id)
  );
};

/** Title + body in the current app language. */
export const operationRequestNotificationText = (notification) => {
  const isArabic = i18n.language === "ar";
  const data = payloadOf(notification);
  const storedTitle = isArabic
    ? notification?.title_arabic || notification?.titleArabic
    : notification?.title;
  const storedBody = isArabic
    ? notification?.body_arabic || notification?.bodyArabic
    : notification?.body;

  const statusText = data.status
    ? i18n.t(`online.referral.statusValue.${data.status}`, data.status)
    : "";
  let built = i18n.t("notifications.operationRequest.body", {
    reference: data.reference_no || "",
    status: statusText,
  });
  if (data.cancellation_reason) {
    built += ` — ${i18n.t("online.referral.cancellationReason")}: ${data.cancellation_reason}`;
  }

  return {
    title: storedTitle || i18n.t("notifications.operationRequest.title"),
    // Prefer the server text in this language (it names the operation); otherwise build it.
    body: storedBody || built,
  };
};

/** The appointment the request was created from. */
export const operationRequestNotificationRoute = (notification) => {
  const appointmentId = payloadOf(notification).appointment_id;
  return appointmentId
    ? `/appointments?appointmentId=${appointmentId}`
    : "/appointments";
};
